import { EquityEntity } from '@genial/services';
import { atom } from 'recoil';

import { equityOperationTypeInitialTab, pagination } from '../constants';
import { EquityOffersParams, EquityOffersBySearchTerm, EquityOffersPositionParams } from '../types';

export const equityOffersAllState = atom({
  key: 'equityOffersAllState',
  default: [] as EquityEntity[],
});

export const equityPositionOffersAllState = atom({
  key: 'equityPositionOffersAllState',
  default: [] as EquityEntity[],
});

export const equityOffersOperationTypeState = atom({
  key: 'equityOffersOperationTypeState',
  default: equityOperationTypeInitialTab,
});

export const equityOffersParamsState = atom({
  key: 'equityOffersParamsState',
  default: {
    ...pagination,
  } as EquityOffersParams,
});

export const equityPositionOffersParamsState = atom({
  key: 'equityPositionOffersParamsState',
  default: {
    ...pagination,
  } as EquityOffersPositionParams,
});

export const equityOffersBySearchTermParamsState = atom({
  key: 'equityOffersBySearchTermParamsState',
  default: {
    ...pagination,
    skipEndpointCall: true,
  } as EquityOffersBySearchTerm,
});

export const equityOffersBySearchTermState = atom({
  key: 'equityOffersBySearchTermState',
  default: [] as EquityEntity[],
});
